<app-card-list [items]="chapters" [trackByFn]="trackByChapterId">
  <ng-template #cardTemplate let-chapter let-i="index">
    <app-project-chapter-progress-card
      [chapters]="chapters"
      [chapter]="chapter"
      [index]="i"
      [isAccessible]="isChapterAccessible(chapter)"
      (goToChapter)="goToChapter($event)"
    ></app-project-chapter-progress-card>
  </ng-template>
</app-card-list>
